var map = {
	"./almaMappings.ts": 9458,
	"./constants.ts": 3601,
	"./feedback.ts": 5373,
	"./i18n.ts": 9142,
	"./languages.ts": 9991,
	"./reCAPTCHA.ts": 8861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5782;